import { Component, effect, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AppBarComponent } from './components/app-bar/app-bar';
import { CartModalComponent } from './components/cart-modal/cart-modal';
import { OptionsModalComponent } from './components/options-modal/options-modal';
import { OrderStatusModalComponent } from './components/order-status-modal/order-status-modal';
import { TableActionsComponent } from './components/table-actions/table-actions';
import { TableSwitchModalComponent } from './components/table-switch-modal/table-switch-modal';
import { AppSettingsService } from './services/app-settings.service';
import { CartService } from './services/cart.service';
import { GeoService } from './services/geo.service';
import { WaiterCallService } from './services/waiter-call.service';
import { TextUtils } from './utility/text.utils';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    TranslateModule,
    AppBarComponent,
    OptionsModalComponent,
    CartModalComponent,
    OrderStatusModalComponent,
    TableSwitchModalComponent,
    TableActionsComponent,
  ],
  templateUrl: './app.html',
})
export class App {
  public waiterService = inject(WaiterCallService);
  public settingsService = inject(AppSettingsService);
  public cartService = inject(CartService);
  public geoService = inject(GeoService);
  private titleService = inject(Title);
  private route = inject(ActivatedRoute);
  private defaultTitle = 'Bistronex QR Menu';

  getDisplayText(value: any): string {
    return TextUtils.getLocalizedText(value, this.settingsService.activeMenuLanguage()?.Code);
  }

  constructor() {
    effect(() => {
      if (this.settingsService.settingsLoaded()) {
        const loc = this.settingsService.locationCheckSettings();
        if (loc.Enabled) {
          this.geoService.promptIfRequired();
        }
      }
    });
    this.route.queryParams.subscribe(async (params) => {
      let changed = false;
      const tableID = params['tableID'];
      if (tableID !== undefined && this.settingsService.tableID() !== (tableID || null)) {
        this.settingsService.tableID.set(tableID || null);
        changed = true;
      }
      const floorID = params['floorID'];
      if (floorID !== undefined && this.settingsService.floorID() !== (floorID || null)) {
        this.settingsService.floorID.set(floorID || null);
        changed = true;
      }

      if (changed) {
        await this.settingsService.resolvePricingTier();
      }
    });

    effect(() => {
      if (this.settingsService.settingsLoaded()) {
        const customer = this.settingsService.customer;
        const newTitle = customer?.Name || this.defaultTitle;
        this.titleService.setTitle(newTitle);
      } else {
        this.titleService.setTitle(this.defaultTitle);
      }
    });
  }
}
